module.exports = __webpack_public_path__ + "static/media/icon_placeholder.78cd8fdd.svg";